export { default as WrmModuleLoader } from './wrm-loader';
